<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex xs12>
          <div class="text-right">
            <v-btn
              color="primary"
              :to="{ name: 'SurveyCreate' }"
              v-if="!showcomponentManager"
            >
              New survey
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex md4 sm6 xs12 mb-3 v-for="(survey, index) in surveys" :key="survey.id">
          <card-survey
            :survey="survey"
            :index="index"
            @selectsurvey="callSelectedSurvey"
            @delete-survey="openModalDestroySurvey"
            @edit-survey="openModalEditSurvey"
            @duplicate-survey="openModalDuplicateSurvey"
          />
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="modalEditSurvey" width="500">
      <v-card>
        <v-card-title class="headline">Edit survey</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form @submit.prevent="updateSurvey">
            <v-text-field
              v-model="title"
              :counter="190"
              label="Title"
              v-validate="'required|max:190'"
              :error-messages="errors.collect('title')"
              data-vv-name="title"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="modalEditSurvey = false">Close</v-btn>
          <v-btn color="primary" @click="updateSurvey">Update</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-dialog v-model="modalDuplicateSurvey" width="500">
      <v-card>
        <v-card-title class="headline">Duplicate survey</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form @submit.prevent="duplicateSurvey">
            <v-text-field
              v-model="title"
              :counter="190"
              label="Title"
              v-validate="'required|max:190'"
              :error-messages="errors.collect('title')"
              data-vv-name="title"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="modalDuplicateSurvey = false">Close</v-btn>
          <v-btn color="primary" @click="duplicateSurvey">Duplicate</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modalDestroySurvey" width="500">
      <v-card>
        <v-card-title class="headline">Delete survey</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <p> Are you sure to eliminate the following survey? </p>
          <p><strong>{{ title }}</strong></p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="modalDestroySurvey = false">No</v-btn>
          <v-btn color="primary" @click="destroySurvey">Yes</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import CardSurvey from './components/CardSurvey.vue';

export default {
  name: 'SurveyList',
  components: {
    CardSurvey
  },
  data () {
    return {
      modalEditSurvey: false,
      modalDestroySurvey: false,
      modalDuplicateSurvey: false,
      index: -1,
      title: '',
      selectedItem: null,
    };
  },
  computed: {
    ...mapGetters('survey', ['surveys']),
    ...mapGetters(['currentUser']),
    showcomponentManager: function () {
      if (this.currentUser.role === 'manager') {
        return true;
      }
      return false;
    },
  },
  mounted () {
    this.loadData();
  },
  methods: {
    ...mapActions('survey', [
      'callSetSurveys',
      'callSelectedSurvey',
      'callEditSurvey',
      'callAddSurvey'
    ]),
    ...mapActions(['setSnackbar', 'setLoading']),

    loadData () {
      this.setLoading(true);
      window.axios.get('surveys')
        .then(response => {
          this.callSetSurveys(response.data.data);
          this.setLoading(false);
        })
        .catch(error => {
          this.setLoading(false);
        });
    },
    openModalDestroySurvey (data) {
      this.modalDestroySurvey = true;
      this.title = data.survey.title;
      this.selectedItem = data.survey;
    },
    openModalEditSurvey (data) {
      this.modalEditSurvey = true;
      this.index = data.index;
      this.title = data.survey.title;
      this.selectedItem = data.survey;
    },
    openModalDuplicateSurvey (data) {
      this.modalDuplicateSurvey = true;
      this.title = '';
      this.selectedItem = data.survey;
    },
    destroySurvey () {
      let _self = this;
      this.setLoading(true);
      window.axios.delete('/surveys/' + this.selectedItem.id + '/destroy')
        .then((response) => {
          let listDeleteSurvey = this.surveys.filter(function (survey) {
            return survey.id !== _self.selectedItem.id;
          });
          
          this.callSetSurveys(listDeleteSurvey);
          this.setLoading(false);
          this.modalDestroySurvey = false;
          this.setSnackbar({
            show: true,
            color: 'success',
            text: 'Survey deleted Successfully!'
          });
        })
        .catch((error) => {
          this.index = -1;
          this.setLoading(false);
        });
    },
    updateSurvey () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.selectedItem.title = this.title;
          this.setLoading(true);
          window.axios.put('/surveys/' + this.selectedItem.id + '/update', this.selectedItem)
            .then((response) => {
              this.callEditSurvey({
                survey: this.selectedItem,
                index: this.index
              });
              this.setSnackbar({
                show: true,
                color: 'success',
                text: 'Updated survey Successfully!'
              });
              this.setLoading(false);

              this.index = -1;
              this.modalEditSurvey = false;
            })
            .catch((error) => {
              this.index = -1;
              this.setLoading(false);
            });
        } else {
          this.setSnackbar({
            show: true,
            color: 'info',
            text: 'Check the form, please.'
          });
        }
      });
    },
    duplicateSurvey (index, survey) {
      this.$validator.validateAll().then(result => {
        if (result) {
          const payload = {
            survey: this.selectedItem,
            title: this.title,
          };
          this.setLoading(true);
          window.axios.post('surveys/duplicate', payload).then((response) => {
            this.setLoading(false);
            this.callAddSurvey(response.data.data);
            this.modalDuplicateSurvey = false;
            this.setSnackbar({
              show: true,
              color: 'success',
              text: 'Duplicate survey Successfully'
            });
          });
        } else {
          this.setSnackbar({
            show: true,
            color: 'info',
            text: 'Check the form, please.'
          });
        }
      });
    }
  }
};
</script>
<style>
  .text-center{
    text-align: center;
  }
  .text-right{
    text-align: right;
  }
  .wrapper-btn{
    position: absolute;
    /* bottom: 0px; */
    left: 35%;
    text-align: center;
    width: 30%;
    margin-top: -25px;
  }
  .icons-pills{
    color:white !important;
    font-size:20px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/client/surveys/List.vue